export const cognitiveSpecification = {
  title: '인지플레이',
  purpose: '인지 콘텐츠의 관리자 등록·연동 방식이 개발 측에서 아직 확정되지 않은 준비 화면입니다.',
  functions: [
    '현재 화면은 사용자 앱과의 실제 콘텐츠 등록 연동을 시작하지 않습니다.',
    '개발 방식이 정해지면 콘텐츠 등록 항목, 단계 구성, 공개·무료·권한 정책, 결과 저장 항목을 기준으로 관리자 기능을 구현합니다.',
  ],
  connections: [
    '인지로그와 회원관리의 인지 리포트 이력은 향후 확정될 콘텐츠 식별자와 회원 수행 결과를 기준으로 연결해야 합니다.',
    '등록 방식과 API·데이터 구조가 정해지면 설정의 등급 및 권한 정책과 함께 연동합니다.',
  ],
  app: '현재는 준비중으로 안내합니다. 개발팀에서 인지 콘텐츠 등록 방식, 필요한 입력 항목, 단계·권한·리포트 저장 규칙을 알려주시면 그 기준으로 관리자와 사용자 앱 연동을 작업하겠습니다.',
}

export const cognitiveDataModelGuide = [
  '개발팀 확정 필요: cognitive_content_id, 단계 ID, 입력 항목, 결과 저장 포맷',
  '확정 후 콘텐츠·단계·권한·리포트는 member_id와 콘텐츠 ID로 연결합니다.',
]

export const cognitiveImplementationGuide = [
  '화면 식별자: cognitive. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 개발팀 확정 필요: 콘텐츠 ID, 등록 항목, 단계, 공개·무료·등급 권한, 결과·리포트 구조.',
  '현재는 준비중 안내만 제공하며 콘텐츠 등록 API나 저장 동작을 실행하지 않습니다.',
  '개발팀이 콘텐츠 모델을 확정한 뒤 등록 항목·권한·결과 저장 구조를 이 화면에 연결합니다.',
  '현재 화면은 운영 UI 목업입니다. 실제 개발에서는 API 응답, 저장 성공·실패, 권한 오류, 빈 목록 상태를 별도로 구현해야 합니다.',
]
